<template>
  <Popup
    :visible="visible"
    :title="section ? 'Modifier la section' : 'Ajouter une section'"
    :add="section == ''"
    :addDisabled="!sectionName"
    @close="$emit('close')"
    @add="$emit('close'); $emit('add', sectionName)"
    @update="$emit('close'); $emit('update', sectionName)"
    @delete="$emit('close'); $emit('delete', sectionName)"
  >
    <div class="flex flex-col gap-8 w-full">
      <!-- Nom du projet -->
      <div class="relative w-[300px]">
        <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">Nom de la section</span>
        <input
          type="text"
          v-model="sectionName"
          placeholder="Avant le devis"
          class="w-full basicInput"
          required
        />
      </div>
    </div>
  </Popup>
</template>

<script>
import Popup from '@/components/Popups/Popup.vue';

export default {
  props: {
    visible: Boolean,
    section: String,
  },
  components: {
    Popup,
  },
  data() {
    return {
      sectionName: '',
    };
  },
  watch:{
    visible(newVal) {
      this.sectionName = this.section;
    }
  }
};
</script>